import { format } from 'date-fns';
import apiService from './api.service';

export const deleteVisit = (visitId) => {
  return apiService({
    method: 'DELETE',
    url: `/qac/visit/${visitId}`,
  });
};

export const getVisitsByDateAndClientId = ({ clientId }) =>
  apiService({
    url: `/qac/check-visit/${clientId}/${format(new Date(), 'yyyy-MM-dd')}`,
  });
